import { useState } from 'react'
import { Title } from '../../components/Title'
import { Trailers } from './Trailers'

export const HomeStory = () => {
    const ss = [...Array(4).keys()].map((i) => ++i)
    const [showModal, setShowModal] = useState(false)
    const [modalImage, setModalImage] = useState()
    const handleOpenModal = (imagepath) => {
        setModalImage(imagepath)
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }
    return (
        <>
            <div className='pt-12 relative'>
                <div className='relative'>
                    <div className='flex'>
                        <img
                            className='w-auto mx-auto'
                            src={`${process.env.PUBLIC_URL}/images/title-wood.png`}
                            alt='Phantom Brave the Lost Hero... !'
                        />
                        <h1 className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-gradient-title text-sm w-full md:text-lg font-pop'>
                            Phantom Brave: <br /> the Lost Hero... !
                        </h1>{' '}
                    </div>
                </div>
                <div className='font-kiwi text-sub md:text-base text-shadow-white mt-12 w-full md:w-4/5 px-4 md:px-0 mx-auto'>
                    <p>
                        Bienvenue dans <span className='text-pborange'>Ivoire</span>, un monde composé d'une infinité de
                        petites îles perdues au milieu de l'immensité de la mer, où débutent les aventures d'une
                        mystérieuse petite fille capable de parler avec{' '}
                        <span className='text-pborange'>les âmes des défunts</span>.
                    </p>{' '}
                    <p>
                        Phantom Brave est un <span className='text-pborange'>RPG</span> dans lequel{' '}
                        <span className='text-pborange'>Marona</span>, l'héroïne, peut se déplacer librement sur toute
                        la carte, mais aussi <span className='text-pborange'>combiner</span> ses amis fantômes aux
                        objets présents tout autour d'elle...{' '}
                        <span className='text-pborange'>Un degré de liberté de jeu rarement atteint</span> pour
                        effectuer ses combats !
                    </p>
                </div>{' '}
                <div className='my-12 md:my-8 px-4'>
                    <div className='flex flex-wrap relative gap-4 justify-center  mt-20'>
                        {ss.map((data, i) => (
                            <div
                                key={i}
                                onClick={() => {
                                    handleOpenModal(data)
                                }}
                                className='w-full md:w-[46%] relative'
                            >
                                <img
                                    className='white-drop-shadow cursor-pointer mx-auto'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-top-${data}-s.webp`}
                                    alt={`screen shot of game system`}
                                />
                            </div>
                        ))}
                    </div>
                    <div
                        onClick={handleCloseModal}
                        className={`z-50 fixed top-0 left-0 w-full h-full bg-black/80 ${
                            showModal ? 'block' : 'hidden'
                        }`}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            className='w-full md:w-[90%] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 m-auto z-30'
                        >
                            <div className='flex flex-row items-center max-w-[1920px] mx-auto md:gap-4'>
                                <div>
                                    {modalImage <= 1 ? (
                                        <img
                                            className='w-full brightness-50 min-w-[30px]'
                                            src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                            alt={`arrow previous`}
                                        />
                                    ) : (
                                        <button onClick={() => setModalImage(modalImage - 1)} className=''>
                                            <img
                                                className='w-full min-w-[30px]'
                                                src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                                alt={`arrow previous`}
                                            />{' '}
                                        </button>
                                    )}
                                </div>
                                <div className='relative'>
                                    <button
                                        onClick={handleCloseModal}
                                        className='absolute top-0 right-0 -translate-y-full translate-x-1/4 md:-translate-y-full md:translate-x-full'
                                    >
                                        <img
                                            className=''
                                            src={`${process.env.PUBLIC_URL}/images/close.png`}
                                            alt='close'
                                        />{' '}
                                    </button>
                                    <img
                                        className='white-drop-shadow '
                                        src={`${process.env.PUBLIC_URL}/images/ss/ss-top-${modalImage}.webp`}
                                        alt={`screen shot of game system`}
                                    />{' '}
                                </div>
                                <div>
                                    {modalImage > 3 ? (
                                        <button>
                                            <img
                                                className='w-full brightness-50 min-w-[30px]'
                                                src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                                alt='right'
                                            />
                                        </button>
                                    ) : (
                                        <button onClick={() => setModalImage(modalImage + 1)} className=' '>
                                            <img
                                                className='w-full min-w-[30px]'
                                                src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                                alt='right'
                                            />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>{' '}
                </div>
                <div className='font-kiwi text-sub md:text-base text-shadow-white mt-12 w-full md:w-4/5 px-4 md:px-0 mx-auto'>
                    <p>
                        C'est dans cet univers où s'affrontent des <span className='text-pborange'>marins</span> sans
                        pitié et des bateaux <span className='text-pborange'>fantômes</span> que commence{' '}
                        <span className='text-pborange'>l'histoire de cette fillette</span>, étrangement proche de{' '}
                        <span className='text-pborange'>l'âme de tous les fantômes</span> qu'elle croise sur sa route...
                    </p>
                </div>{' '}
            </div>
        </>
    )
}
